import { theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-8px);
  }
  60% {
    transform: translateY(-4px);
  }
`;

export const TravelProtectionV2Wrapper = styled.div`
  width: 1200px;
  border-radius: 40px;
  background-color: #ffffff;
  margin: 0 auto;
  align-items: center;
  position: relative;
`;

export const DiscoveryBarSection = styled.div`
  width: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  position: absolute;
  top: -55px;

  animation: ${bounce} 1s 5;
  transition: all 0.3s ease;

  &:hover {
    animation-play-state: paused;
    transform: translateY(-2px);
  }

  /* Left double arrows (two chevrons stacked) */
  &::before {
    content: "";
    width: 16px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='32' viewBox='0 0 24 32' fill='none'%3E%3Cpolyline points='6 4 12 10 18 4' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpolyline points='6 14 12 20 18 14' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    flex-shrink: 0;
    margin-top: 10px;
  }

  /* Right double arrows (two chevrons stacked) */
  &::after {
    content: "";
    width: 16px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='32' viewBox='0 0 24 32' fill='none'%3E%3Cpolyline points='6 4 12 10 18 4' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpolyline points='6 14 12 20 18 14' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    flex-shrink: 0;
    margin-top: 10px;
  }

  & > * {
    color: ${theme.whiteText};
    font-weight: 700;
    font-size: 13px;
    text-align: center;
  }
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 900;
  background: linear-gradient(90deg, #ddf4ff 0%, #c2dfff 103.59%);
  color: #0e5b99;

  padding: 18px 0px;
  width: 286px;
  display: flex;
  align-items: flex-start;
  justify-content: right;
  position: relative;
  border-radius: 40px 0 0 40px;

  /* Border/Outline arrow (second arrow) */
  &::before {
    content: "";
    position: absolute;
    right: -20px;
    top: -2px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 34px 0 34px 13px;
    border-color: transparent transparent transparent #e0efff;
  }

  /* Main arrow/Tab shape pointing right */
  &::after {
    content: "";
    position: absolute;
    right: -13px;
    top: -2px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 34px 0 34px 13px;
    border-color: transparent transparent transparent #c2dfff;
  }
`;

export const SectionIcon = styled.img`
  width: 15px;
  height: 15px;
  object-fit: contain;
`;

export const PlanCards = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-left: 10px;
`;

export const PlanCard = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 11px 16px;
  box-sizing: border-box;
`;

export const PlanIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  margin-right: 16px;
`;

export const PlanIconV2 = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export const PlanContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const PlanTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const PlanTitleContainer = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #000000;
  line-height: 100%;
  display: flex;
  align-items: center;
`;

export const NewTag = styled.img`
  height: 14px;
  width: auto;
  object-fit: contain;
`;

export const PlanDetails = styled.div`
  font-size: 12px;
  color: #4a4a4a;
  line-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ArrowIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-left: 16px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TagImage = styled.img`
  height: 14px;
  object-fit: contain;
`;

export const TagContainer = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

export const ChevStateWrap = styled.div`
  border-radius: 22px;
  padding: 2px;
  background: #eaf5ff;
  transform: rotate(-90deg);

  svg {
    width: 10px;
    height: 10px;
  }
`;

export const PlanSeparator = styled.div`
  width: 1px;
  height: 100%;
  background: #e0e0e0;
  align-self: center;
`;
